/**
 * @generated SignedSource<<d45b06f9796d8c446c19174db7ace281>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityUuids"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scmpPlusPaywallTypeIds"
    }],
    v1 = [{
      "fields": [{
        "kind": "Variable",
        "name": "paywallTypeIds",
        "variableName": "scmpPlusPaywallTypeIds"
      }],
      "kind": "ObjectValue",
      "name": "exclude"
    }, {
      "fields": [{
        "kind": "Variable",
        "name": "entityUuids",
        "variableName": "entityUuids"
      }],
      "kind": "ObjectValue",
      "name": "filter"
    }, {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "hooksUseReadingHistoryWithArticleQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "ArticleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, {
              "kind": "InlineDataFragmentSpread",
              "name": "readingHistoryPanelArticle",
              "selections": [v4 /*: any*/, v2 /*: any*/, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, v7 /*: any*/, {
                "alias": null,
                "args": null,
                "concreteType": "Application",
                "kind": "LinkedField",
                "name": "application",
                "plural": false,
                "selections": [v2 /*: any*/],
                "storageKey": null
              }],
              "args": null,
              "argumentDefinitions": []
            }, {
              "kind": "InlineDataFragmentSpread",
              "name": "readingHistoryActionMenuBookmarkButtonArticle",
              "selections": [v5 /*: any*/, v3 /*: any*/],
              "args": null,
              "argumentDefinitions": []
            }, {
              "kind": "InlineDataFragmentSpread",
              "name": "readingHistoryActionMenuSocialButtonArticle",
              "selections": [v2 /*: any*/, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, v7 /*: any*/],
              "args": null,
              "argumentDefinitions": []
            }, {
              "kind": "InlineDataFragmentSpread",
              "name": "hooksRemoveReadingHistoryArticle",
              "selections": [v2 /*: any*/, v3 /*: any*/],
              "args": null,
              "argumentDefinitions": []
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hooksUseReadingHistoryWithArticleQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "ArticleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/, v7 /*: any*/, {
              "alias": null,
              "args": null,
              "concreteType": "Application",
              "kind": "LinkedField",
              "name": "application",
              "plural": false,
              "selections": [v2 /*: any*/, v8 /*: any*/],
              "storageKey": null
            }, v8 /*: any*/],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "09c86431a1ac0204ba9edf1bd9f7cdda",
      "id": null,
      "metadata": {},
      "name": "hooksUseReadingHistoryWithArticleQuery",
      "operationKind": "query",
      "text": "query hooksUseReadingHistoryWithArticleQuery(\n  $entityUuids: [String]!\n  $first: Int!\n  $scmpPlusPaywallTypeIds: [String]\n) {\n  articles(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, filter: {entityUuids: $entityUuids}, first: $first) {\n    edges {\n      node {\n        entityUuid\n        entityId\n        ...readingHistoryPanelArticle\n        ...readingHistoryActionMenuBookmarkButtonArticle\n        ...readingHistoryActionMenuSocialButtonArticle\n        ...hooksRemoveReadingHistoryArticle\n        id\n      }\n    }\n  }\n}\n\nfragment hooksRemoveReadingHistoryArticle on Article {\n  entityUuid\n  entityId\n}\n\nfragment readingHistoryActionMenuBookmarkButtonArticle on Article {\n  urlAlias\n  entityId\n}\n\nfragment readingHistoryActionMenuSocialButtonArticle on Article {\n  entityUuid\n  entityId\n  urlAlias\n  headline\n  socialHeadline\n}\n\nfragment readingHistoryPanelArticle on Article {\n  __typename\n  entityUuid\n  entityId\n  urlAlias\n  headline\n  socialHeadline\n  application {\n    entityUuid\n    id\n  }\n}\n"
    }
  };
}();
node.hash = "cbde35cb215893f736ea456fd1a2e149";
export default node;